import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Header } from '../../shared/components/header/header';
import { Sidebar } from '../../shared/components/sidebar/sidebar';

@Component({
  selector: 'app-tenant-layout',
  imports: [RouterModule, Header, Sidebar],
  templateUrl: './tenant-layout.html',
  styleUrl: './tenant-layout.scss'
})
export class TenantLayout {

}
